import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  referenceListsModule: {
    marginBottom: pxToRem(16),
    selectors: {
      '&:last-child': {
        marginBottom: pxToRem(40),
      },
    },
  },
  searchSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    paddingBottom: pxToRem(25),
  },
  scrollablePane: {
    width: 'fit-content',
    '& [role=grid]': {
      maxHeight: pxToRem(700),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
    },
    '& .ms-DetailsList-headerWrapper': {
      flex: '0 0 auto',
    },
    '& .ms-DetailsList-contentWrapper': {
      flex: '1 1 auto',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  },
  moreProductIds: {
    color: theme.palette.themePrimary,
  },
  tooltipContent: {
    margin: pxToRem(10),
    padding: pxToRem(15),
  },
});
